
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./Navbar.css";
import { auth } from "../firebase";
import { signOut } from "firebase/auth";
import { trackSearch } from "../utils/analytics";

export default function Navbar({ user, isAdmin }) {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");

  const handleSearch = (e) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      // Track search analytics
      trackSearch(searchQuery.trim());
      navigate(`/search?q=${encodeURIComponent(searchQuery.trim())}`);
      setSearchQuery("");
    }
  };

  const openMenu = () => {
    setMenuOpen(true);
    document.body.classList.add('nav-lock');
  };

  const closeMenu = () => {
    setMenuOpen(false);
    document.body.classList.remove('nav-lock');
  };

  const handleMenuItemClick = (action) => {
    closeMenu();
    if (action) action();
  };

  const scrollToSection = (sectionId) => {
    // First navigate to home page if not already there
    if (window.location.pathname !== '/') {
      navigate('/');
      // Wait for navigation to complete, then scroll
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 100);
    } else {
      // Already on home page, just scroll
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  };

  // Close menu on escape key
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape' && menuOpen) {
        closeMenu();
      }
    };
    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, [menuOpen]);

  return (
    <>
      <nav className="navbar">
        <div className="navbar-content">
          {/* Hamburger Menu */}
          <button className={`menu-btn ${menuOpen ? 'active' : ''}`} onClick={openMenu}>
            <div className="hamburger-icon">
              <span></span>
              <span></span>
              <span></span>
            </div>
          </button>

          {/* Logo */}
          <div className="navbar-logo" onClick={() => navigate("/")} style={{cursor: "pointer"}}>
            <img src="/images/Store Logo - Kid's Vibes with Earrings.png" alt="Kids Vibes" />
          </div>

          {/* Search Bar */}
          <form onSubmit={handleSearch} className="search-form">
            <div className="search-container">
              <input 
                type="text"
                placeholder="Search items"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="search-input"
              />
              <button type="submit" className="search-button">
                <img src="/images/icons8-search-50.png" alt="Search" />
              </button>
            </div>
          </form>
        </div>
      </nav>

      {/* Full-Screen Menu Overlay */}
      <div className={`menu-panel ${menuOpen ? 'open' : ''}`}>
        <button className="menu-close" onClick={closeMenu} aria-label="Close menu">
          ✕
        </button>
        
        <img src="/images/Store Logo - Kid's Vibes with Earrings.png" className="panel-logo" alt="Kid's Vibes" />
        
        <nav className="menu-list">
          {!user ? (
            <>
              <button className="menu-link" onClick={() => handleMenuItemClick(() => navigate('/login'))}>
                Login
              </button>
              <button className="menu-link" onClick={() => handleMenuItemClick(() => scrollToSection('footer'))}>
                Contact Us
              </button>
              <button className="menu-link" onClick={() => handleMenuItemClick(() => scrollToSection('location'))}>
                Location
              </button>
            </>
          ) : (
            <>
              <div className="user-email">
                {user.email}
              </div>
              {isAdmin && (
                <button className="menu-link" onClick={() => handleMenuItemClick(() => navigate('/admin'))}>
                  Admin Panel
                </button>
              )}
              <button className="menu-link" onClick={() => handleMenuItemClick(() => scrollToSection('footer'))}>
                Contact Us
              </button>
              <button className="menu-link" onClick={() => handleMenuItemClick(() => scrollToSection('location'))}>
                Location
              </button>
              <button className="menu-link logout" onClick={() => handleMenuItemClick(() => signOut(auth))}>
                Logout
              </button>
            </>
          )}
        </nav>
      </div>
    </>
  );
}

